module.exports = __webpack_public_path__ + "static/media/6.38e42fa9.jpg";